import React from 'react';
import Image from 'next/image';

import { CartProps } from '~/types/cart';
import { CREDIT_COMPONENT_TYPES } from '~/constants/checkout';

import { Credits } from '~/components/checkout/CreditsCoupons/Credits';
import { ManualCouponButton } from '~/components/checkout/CreditsCoupons';
import CheckGreen from '~/public/font-awesome/check-circle-dollar.png';

interface CollapsedSummaryProps {
  cart?: CartProps;
  hasCoupons?: boolean;
  onClickCoupon: () => void;
}

export default React.memo(function CollapsedSummary({
  cart,
  hasCoupons,
  onClickCoupon,
}: Readonly<CollapsedSummaryProps>): React.ReactElement {
  const couponDesc = cart?.coupon_desc ?? '';
  let couponsEl = null;
  let manualCouponEl = null;
  let summaryEl = null;

  if (couponDesc) {
    couponsEl = (
      <div className="flex items-center">
        <Image
          src={CheckGreen}
          alt="check"
          width={16}
          className="mr-2 inline-block"
        />
        <span className="font-bold">{couponDesc}</span>
        <span>&nbsp;coupon applied</span>
      </div>
    );
  } else if (hasCoupons) {
    couponsEl = (
      <div className="flex items-center">
        <div>
          <span className="mr-2">You have coupons available</span>
          <button
            onClick={onClickCoupon}
            onKeyDown={onClickCoupon}
            className="text-bolt hover:underline"
          >
            View available coupons
          </button>
        </div>
      </div>
    );
  }

  // Only show manual coupon button if no coupon is applied
  if (!couponDesc) {
    manualCouponEl = (
      <ManualCouponButton label="Add a discount code" onClick={onClickCoupon} />
    );
  }

  // Separate to utilize grid gap in parent
  if (couponsEl || cart?.credit || cart?.available_credit) {
    summaryEl = (
      <div>
        <Credits cart={cart} type={CREDIT_COMPONENT_TYPES.COLLAPSED} />
        {couponsEl}
      </div>
    );
  }

  return (
    <>
      {summaryEl}
      {manualCouponEl}
    </>
  );
});
